import { memo } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider";

const AuthRoute = memo(function AuthRoute({ children }) {
  const { user, loading, status } = useAuth();


  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-lg font-semibold">Loading...</p>
      </div>
    );
  }

  if (user && user?._id && status === "authenticated") {
    return <Navigate to="/dashboard" />;
  }

  return children;
});

export default AuthRoute;
